import UserApi from './components/User';
import Subscriptions from './components/Subscriptions';
import PersonalPlan from './components/PersonalPlan';
import Auth from './components/Auth';
import Analytics from './components/Analytics';

function ApiInstance() {
    const user = new UserApi();
    const subscriptions = new Subscriptions();
    const personalPlan = new PersonalPlan();
    const auth = new Auth();
    const analytics = new Analytics();

    return {
        user,
        subscriptions,
        personalPlan,
        auth,
        analytics,
    };
}

export default ApiInstance();
